export const TRESOR_USP_BULLETS = [
  'Nur Sie kommen an Ihre Dateien, wir nicht',
  'Verschlüsselung passiert auf Ihrem Gerät, nachprüfbar',
  'Server in Deutschland, DSGVO-konform inklusive AVV',
  'Faire Preise, jederzeit kündbar',
];

export const COMPARISON_ROWS = [
  ['Verschlüsselung', 'Lokal · Zero-Knowledge', 'Auf dem Server (Provider hält den Schlüssel)'],
  ['Server-Standort', 'Deutschland', 'Global (US Cloud Act)'],
  ['Data-Mining & KI-Training', 'Technisch unmöglich', 'Teil der AGB'],
  ['B2B DSGVO-konform (AVV)', 'Inkludiert', 'Nur in teuren Enterprise-Tarifen'],
];

export const LANDING_FAQS = [
  {
    q: 'Was ist tresor.datenputzer.de?',
    a: (
      <>
        <strong>tresor.datenputzer.de</strong> ist das Cloudspeicher-Endkundenprodukt von Datenputzer. Sie bekommen
        verschlüsselten Cloud-Speicher, der Zero-Knowledge arbeitet: Dateien werden bei Ihnen lokal im Browser
        verschlüsselt, bevor sie hochgeladen werden. Der Ablauf ist transparent dokumentiert, Sie können ihn unter{' '}
        <a href="/docs" className="ed-link">/docs</a> nachvollziehen.
      </>
    ),
  },
  {
    q: 'An wen richtet sich tresor.datenputzer.de?',
    a: (
      <>
        Direkt an <strong>Endkunden</strong>: Privatpersonen, Freiberufler und kleine Teams, die hochsicheren
        Speicher einfach nutzen wollen, ohne sich an große US-Cloud-Riesen binden zu müssen. Wenn Sie eine
        Alternative zu Google Drive oder Dropbox suchen, bei der Sie nachvollziehen können, wie Ihre Daten lokal
        verschlüsselt werden, ist der Tresor für Sie gedacht.
      </>
    ),
  },
  {
    q: 'Wie funktioniert die Zero-Knowledge-Verschlüsselung?',
    a: (
      <>
        Jede Datei wird direkt in Ihrem Browser mit AES-GCM verschlüsselt, bevor sie über das Internet geht. Ihr
        Tresor-Passwort wird <strong>nie an uns übertragen oder gespeichert</strong>. Auf dem Server liegt nur eine
        verschlüsselte Hülle des Master-Schlüssels (<code>passwordWrapped</code>). Erst wenn Sie lokal Ihr Passwort
        eingeben, wird diese Hülle im Browser geöffnet und der Schlüssel kurz im RAM genutzt. Ohne Ihr Passwort oder
        Ihre Recovery-Phrase können wir Ihre Inhalte nicht lesen.
      </>
    ),
  },
  {
    q: 'Warum ist das sicherer als Google Drive oder Dropbox?',
    a: (
      <>
        Große US-Anbieter verschlüsseln zwar auf ihren Servern, <strong>besitzen aber auch den Schlüssel</strong>.
        Sie können Dateien für KI-Training, Werbeprofile oder auf Behördenanfrage scannen. Der Datenputzer-Tresor ist
        bewusst als Endkunden-Alternative gebaut: Sie verschlüsseln lokal, der Schlüssel bleibt bei Ihnen. Selbst bei
        einem Server-Hack fänden Angreifer nur unlesbaren Datensalat. Hosting in Deutschland, DSGVO-konform.
      </>
    ),
  },
  {
    q: 'Was passiert, wenn ich mein Passwort vergesse?',
    a: (
      <>
        Ihr Passwort wird weder gespeichert noch an den Server gesendet, deshalb gibt es keinen klassischen
        Reset-Link per E-Mail. Bei der Einrichtung erhalten Sie einen <strong>12-Wörter-Notfallschlüssel</strong>{' '}
        (Recovery-Phrase), mit dem Sie den Tresor entsperren und ein neues Passwort setzen können. Verlieren Sie Passwort
        und Notfallschlüssel, sind die Daten unwiderruflich verloren. Das ist der Preis echter Privatsphäre.
      </>
    ),
  },
];
